module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('strong', [_vm._v("通讯管理机")]), _vm._v(" v1.0.0 © 版权所有 2017\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da736a7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/Footer.vue
// module id = 94
// module chunks = 0